export const daysUntilDeletion = (trashedAt: Date) => {
  const currentDate = new Date();
  const deletionDate = new Date(trashedAt);
  deletionDate.setDate(trashedAt.getDate() + 14);

  const timeDifference = deletionDate.getTime() - currentDate.getTime();
  return Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
};
